import React from 'react';

/** Trailing arrow for primary pill CTAs (see DESIGN.md "Hero actions"). */
const ArrowIcon = () => (
  <svg className="btn-arrow" viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false">
    <path d="M4 10h11m-4.5-5 5 5-5 5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ArrowIcon;
